import React, { useState, useEffect } from 'react'
import Dashboard from 'src/views/dashboard/Dashboard'
import Hr_Dashboard from './hr-dashboard'

const HrDashbard = () => {
  
  useEffect(()=> {

  },[])
  return (
    <div>
        {/* <h2> Hr Panel</h2> */}
        <Hr_Dashboard/>
    </div>

  )
}
export default HrDashbard